var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistribution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    fill: "white",
    enableBackground: "new 0 0 512.437 512.437",
    height: 20,
    viewBox: "0 0 512.437 512.437",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.437 238.914 88.334-50.98-88.334-51.001-88.337 51.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.776 213.913-88.339 50.981v102.035l88.339-51.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.437 264.894-88.342-50.982v102.013l88.342 51.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.285 307.959 51.786-51.786-51.786-51.788-21.213 21.213 15.612 15.612h-64.908v30h64.832l-15.536 15.537z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.242 57.356v53.709l15.195-8.773 14.805 8.548v-52.996l15.329 15.329 21.213-21.213-51.786-51.786-51.788 51.786 21.213 21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.6 150.885 26.897 15.529 65.724-65.724c7.792 4.284 16.576 6.57 25.715 6.57h.001c14.29 0 27.727-5.565 37.83-15.67 20.859-20.858 20.859-54.8.001-75.66h-.001c-20.859-20.859-54.8-20.859-75.661 0-17.177 17.178-20.195 43.222-9.082 63.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.767 420.931c-17.178-17.178-43.221-20.195-63.53-9.082l-65.74-65.74-26.897 15.529 71.424 71.424c-11.113 20.309-8.095 46.352 9.083 63.53 10.431 10.429 24.13 15.644 37.83 15.644s27.4-5.215 37.83-15.644c10.104-10.104 15.67-23.54 15.67-37.831s-5.566-27.726-15.67-37.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.241 454.652v-52.97l-14.804 8.548-15.196-8.773v53.531l-15.741-15.741-21.213 21.212 51.786 51.787 51.787-51.787-21.213-21.212z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.272 361.638-26.897-15.529-65.724 65.724c-7.792-4.284-16.576-6.57-25.715-6.57-14.291 0-27.726 5.565-37.831 15.67-20.858 20.859-20.858 54.801 0 75.66 10.104 10.104 23.54 15.67 37.831 15.67s27.726-5.565 37.83-15.67c17.178-17.177 20.196-43.22 9.082-63.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.936 107.235c8.864 0 17.722-2.197 25.7-6.562l65.74 65.741 26.897-15.529-71.408-71.408c4.284-7.792 6.57-16.576 6.57-25.715 0-14.291-5.565-27.727-15.67-37.831-20.858-20.858-54.8-20.86-75.66 0-20.86 20.859-20.86 54.801 0 75.661 10.43 10.428 24.13 15.643 37.831 15.643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73 286.823-15.613-15.613h65.708v-30h-65.631l15.536-15.536-21.214-21.213-51.786 51.788 51.786 51.787z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistribution);
export default __webpack_public_path__ + "static/media/distribution.4d00269c3c5eafba6c5aa6831dd93fee.svg";
export { ForwardRef as ReactComponent };